import React, { useEffect, useState } from "react";
import "./Custom.css";
import Lottie from "lottie-react";
import techAnimation from "../assests/CustomSDanimation.json";
export default function Custom() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div id="Custom" class="Custom wf-section">
      <div className="techHero1">
              <div className="topCurve"></div>
              <div className="techCardFull">
                <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
                <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
                <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
                <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
                <div className="menu-icon-curve1_MV"></div>
                <div className="menu-icon-curve2_MV"></div>
                <div className="logo_curve1_Mo"></div>
                <div className="logo_curve2_Mo"></div>
                <div className="techContent1_M">
                  <h1 className="tech-title1_M">CUSTOM<br/><span>SOFTWARE</span><br/>DEVELOPMENT</h1>
                </div>
                <div className="tech-animation2">
                  <Lottie animationData={techAnimation} loop={true} speed={0.1} />
                </div>
              </div>
            </div>
            <div className="softwareSection">

  <p className="topDescription">
    Custom software development is the process of designing, creating, deploying and maintaining software
    for a specific set of users, functions or organizations. In contrast to commercial off-the-shelf software
    (COTS), custom software development aims at a narrowly defined set of requirements.
  </p>

  <div className="softwareGrid">
    <div className="softwareCard">
      <h2>Corporate & Interorganizational Software Systems</h2>
      <p>
        We build software that automates enterprise-wide processes and covers interdepartmental information
        flows, and may also include transactions with customers, vendors and partners.
      </p>
      <span>
        ERP, operations management software, SCM, EAM, MES, POS, claims processing software, HCM/HRM.
      </span>
    </div>
    <div className="softwareCard">
      <h2>Departmental Software</h2>
      <p>
        We build software with features that are unmet by mass-market commercial or free software to cover
        the needs of a particular department within your organization.
      </p>
      <span>
        CRM, inventory management, financial management software, RIS, PACS.
      </span>
    </div>
    <div className="softwareCard">
      <h2>Software for a Specific Business Function</h2>
      <p>
        We build software that fully covers business-unique and industry-specific functions, thus it doesn’t
        need time-consuming and complicated customization as is the case with market-available software products.
      </p>
      <span>
        price management software, clinical decision support app, specialized accounting/treasury management software,
        invoicing and billing software.
      </span>
    </div>
    <div className="softwareCard">
      <h2>Customer Self-service Apps</h2>
      <p>
        We build applications that help your organization deliver tailored customer experiences to win the market competition.
      </p>
      <span>
        mobile banking apps, patient portals, shopping apps.
      </span>
    </div>
    <div className="softwareCard">
      <h2>Software Support Services</h2>
      <p>
        Software support services are generally technical support or break/fix services that are delivered forspecific software products.
        These services include revenue derived from long-term technical-support contracts or pay-as-you-go, incident-based support.
      </p>
    </div>

  </div>

</div>
    </div>
  );
}
